import { FC } from "react";

import { InputWithCornerHint } from "../atoms/InputWithCornerHint";
import { t } from "i18next";

export const FormCategory: FC<any> = () => {
  return (
    <div className="w-full mt-3">
      <InputWithCornerHint
        label={t("inventory.views.category")}
        span=""
        id=""
        name=""
        type="text"
        placeholder={t("inventory.views.category")}
        onChange={() => {}}
        error={false}
      />
    </div>
  );
};
